/**
 * @file url controller
 * 
 */

const devBase = {
    icafileUrl: '/dev'
};

const prodBase = {
    icafileUrl: '/'
}

const baseUrls = process.env.NODE_ENV === 'development' ? devBase : prodBase;

export default baseUrls;
